export const STUDENT_STATUS_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'IN_ACTIVE' }
];
